import request from "@/utils/request";

/**
 * 将后端返回的文件地址转成浏览器可访问的地址。
 * 外网(ngrok HTTPS)场景下，localhost 绝对地址会被 Mixed Content / 私网访问拦截，
 * 需改成相对路径，走前端代理（如 /app-api/profile/...）。
 */
export function resolveFileUrl(url) {
  if (!url || typeof url !== "string") return url;
  const trimmed = url.trim();
  if (!trimmed) return trimmed;
  if (trimmed.startsWith("blob:") || trimmed.startsWith("data:")) return trimmed;

  try {
    if (/^https?:\/\//i.test(trimmed)) {
      const u = new URL(trimmed);
      if (u.hostname === "localhost" || u.hostname === "127.0.0.1") {
        return u.pathname + u.search + u.hash;
      }
      return trimmed;
    }
  } catch (_) {
    /* ignore */
  }

  const base = process.env.VUE_APP_BASE_API || "";
  if (trimmed.startsWith("/profile") && base.startsWith("/") && !trimmed.startsWith(base)) {
    return base.replace(/\/$/, "") + trimmed;
  }
  return trimmed;
}

/**
 * 从上传接口响应中解析文件 URL
 * - /common/upload 返回 { url }
 * - /ossUpload/uploadFile 返回 { data: url }
 */
function extractUploadUrl(res) {
  let url = "";
  if (res.url) url = res.url;
  else if (typeof res.data === "string" && /^https?:\/\//.test(res.data)) url = res.data;
  else if (typeof res.msg === "string" && /^https?:\/\//.test(res.msg)) url = res.msg;
  else if (typeof res.fileName === "string" && res.fileName) {
    const base = process.env.VUE_APP_BASE_API || "";
    url = (base.startsWith("/") ? base.replace(/\/$/, "") : "") + res.fileName;
  } else {
    throw new Error(res.msg || "上传失败");
  }
  return resolveFileUrl(url);
}

/**
 * 上传文件到服务端
 * @param {File} file - 要上传的文件对象
 * @returns {Promise<string>} 返回上传后的文件 URL
 */
export function uploadFile(file) {
  const formData = new FormData();
  formData.append("file", file);
  const uploadPath = process.env.VUE_APP_UPLOAD_PATH || "/ossUpload/uploadFile";

  return request({
    url: uploadPath,
    method: "post",
    data: formData,
    timeout: 60000,
  })
    .then(extractUploadUrl)
    .catch((err) => {
      console.error("文件上传失败:", err);
      throw err;
    });
}
